import React from 'react';
import classNames from 'classnames';
import { ATMLabel } from 'shared-it-appmod-ui';
import { INotification } from 'src/models/notification.model';
import Lang from 'src/libraries/language';
import { RequestStatus } from 'src/constants';
import styles from './request-status.module.scss';

type IProps = {
  data?: INotification;
  className?: string;
};

const StatusProject: React.FC<IProps> = ({ data = null, className }) => {
  if (!data) {
    return null;
  }

  let color = '#D3D3D3';
  let status = Lang.LBL_CANCELLED;

  switch (data.requestStatus) {
    case RequestStatus.Cancelled: {
      color = '#D3D3D3';
      status = Lang.LBL_CANCELLED;
      break;
    }

    case RequestStatus.PendingApproval: {
      color = '#fed8b1';
      status = Lang.LBL_PENDING_APPROVAL;
      break;
    }
  }

  return (
    <ATMLabel
      className={classNames(styles.container, className)}
      horizontal
      style={{ backgroundColor: color, lineHeight: '20px', float: 'right' }}
    >
      {status}
    </ATMLabel>
  );
};

export default StatusProject;
